import { Typography, Box } from 'vendor/material';
import { fontWeightBold } from '../../../../../utils/fontWeightConstants';
import { Card, Button, Divider, Link } from '@tackle-io/platform-ui';
import { makeStyles, CircularProgress } from 'vendor/material';
import { useHistory } from 'react-router-dom';
import {
  FormProgressQueryResult,
  isComplete,
  percentComplete,
} from '../../../../../utils/yup-extended';

const useStyles = (isProgressComplete: boolean) =>
  makeStyles((theme) => {
    return {
      sideBarContainer: {
        maxWidth: '331px',
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(1),
      },
      title: {
        color: theme.palette.NEUTRAL900,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: fontWeightBold,
      },
      description: {
        color: theme.palette.NEUTRAL900,
        paddingBottom: theme.spacing(2),
        '& > a': {
          textDecoration: 'none',
        },
      },
      progressRoot: {
        position: 'relative',
      },
      progressBottom: {
        color: theme.palette.NEUTRAL040,
      },
      progressTop: {
        color: isProgressComplete
          ? theme.palette.GREEN400
          : theme.palette.BLUE400,
        position: 'absolute',
        left: 0,
      },
      primaryActionButton: {
        '& > span': {
          textTransform: 'none',
        },
      },
      secondaryActionButton: {
        borderColor: `${theme.palette.NEUTRAL050} !important`, // Important is used to override the platform-ui settings for buttons
        '& > span': {
          textTransform: 'none',
        },
      },
      errorMessage: {
        textAlign: 'center',
        color: theme.palette.RED400,
      },
    };
  })();

const sidebarDescription =
  'When details are completed, complete your configuration to connect to the marketplace.';

const VendorConfigSidebar = ({
  cloudString,
  onAfterCompleted,
  progress,
}: {
  cloudString: string;
  onAfterCompleted: (cloud: string) => void;
  progress: FormProgressQueryResult;
}) => {
  const history = useHistory();
  const classes = useStyles(isComplete(progress));

  return (
    <div className={classes.sideBarContainer}>
      <Card paperStyle={{ border: `1px solid #0052CC` }}>
        <div className={classes.header}>
          <Typography className={classes.title}>
            Complete configuration
          </Typography>
          <div className={classes.progressRoot}>
            <CircularProgress
              variant={progress.loading ? 'indeterminate' : 'determinate'}
              size={20}
              thickness={7}
              value={100}
              role="none"
              className={classes.progressBottom}
            />
            <CircularProgress
              variant={progress.loading ? 'indeterminate' : 'determinate'}
              size={20}
              thickness={7}
              value={percentComplete(progress)}
              className={classes.progressTop}
            />
          </div>
        </div>
        <Typography className={classes.description}>
          {sidebarDescription}
        </Typography>
        <Button
          fullWidth
          appearance="primary"
          disabled={!isComplete(progress)}
          loading={progress.loading}
          className={classes.primaryActionButton}
          onClick={() => {
            onAfterCompleted(cloudString);
            history.push('/settings/account/marketplace/');
          }}
        >
          Complete
        </Button>
        <>
          <Box my={2}>
            <Divider />
          </Box>
          <Link to="/integrations">
            <Button
              fullWidth
              variant="outlined"
              appearance="primary"
              className={classes.secondaryActionButton}
            >
              Save draft and exit
            </Button>
          </Link>
        </>
      </Card>
    </div>
  );
};

export default VendorConfigSidebar;
